'use strict';

import MyApi from '@api/my';

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[app::services::my::dashboard]';

const trainingStatus = async () => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.trainingStatus();
    return response.data;
}

const eventStatus = async () => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await MyApi.eventStatus();
    return response.data;
}

export default {
    trainingStatus,
    eventStatus
};